import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import styled from 'styled-components';
import { connect } from '../../Store';

const Wrapper = styled.div`
  max-width: ${rem(200)};
  display: flex;
  font-weight: 200;
`;

const Plus = styled.div`
  width: ${rem(32)};
  height: ${rem(32)};
  margin-left ${rem(5)};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${rem(24)};
    cursor: pointer;
`;

const Minus = styled(Plus)`
margin-left 0;
margin-right: ${rem(5)};
`;

class InfoBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      typingTimeout: 0,
    };
  }

  handleChange(newValue = -1, plus = false, minus = false) {
    let { value } = this.state;
    const { changeValue } = this.props;

    let wasValueChanged = false;

    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }

    if (newValue === -1) {
      if (plus) {
        value = Number(value) + 1;
        wasValueChanged = true;
      } else if (minus && value > 1) {
        value = Number(value) - 1;
        wasValueChanged = true;
      }
    } else if (Number(newValue) >= 0) {
      value = Number(newValue);
      wasValueChanged = true;
    }
    if (wasValueChanged) {
      this.setState({
        value: value === 0 ? 1 : value,
        typingTimeout: setTimeout(() => {
          changeValue(value === 0 ? 1 : value);
        }, 1000),
      });
    }
  }

  render() {
    const { value } = this.state;
    const { readOnly } = this.props;

    return (
      <Wrapper>
        <Minus onClick={() => this.handleChange(-1, false, true)}>-</Minus>
        <Input
          style={{
            maxWidth: rem(32),
            maxHeight: rem(32),
            padding: 0,
            textAlign: 'center',
          }}
          readOnly={readOnly}
          value={value}
          onChange={e =>
            !readOnly ? this.handleChange(e.target.value, false, false) : {}
          }
        />
        <Plus
          onClick={() => (!readOnly ? this.handleChange(-1, true, false) : {})}
        >
          +
        </Plus>
      </Wrapper>
    );
  }
}

InfoBox.propTypes = {
  value: PropTypes.number,
  changeValue: PropTypes.func,
  readOnly: PropTypes.bool,
};

InfoBox.defaultProps = {
  value: 0,
  changeValue: () => {},
  readOnly: false,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(InfoBox);



// WEBPACK FOOTER //
// ./src/Components/QuantityPicker/index.jsx